<template>
  <div>
    <!--:style="boxStyle"-->
    <table ref="table" class="table table-hover table-borderless table-responsive border-danger">
      <thead ref="thead">
        <slot name="thead">
          <tr>
            <template v-if="complete">
              <th :style="stylebtn(3)" colspan="3" v-text="_trans('Control')"></th>
              <th :style="stylebtn()">
                <button class="btn btn-primary small" @click="addelement()"><i class="di di-plus"></i></button>
              </th>
            </template>
            <template v-else-if="move">
              <th :style="stylebtn(2)" colspan="2" v-text="_trans('Control')"></th>
            </template>
            <th v-for="(col, key) in cols" :key="key" :style="stylecol(col)" @click="changesort(col.id)">
              <span style="cursor: pointer;" v-text="col.title"></span>
              <span v-if="sortcol === col.id && getsorted() === 'asc'">&#x25BE;</span>
              <span v-if="sortcol === col.id && getsorted() === 'des'">&#x25B4;</span>
            </th>
            <th v-if="details" :style="stylebtn(2)"></th>
            <td v-if="fadd" :style="stylebtn()">
              <button class="btn btn-secondary small " @click="addelement()"><i class="di di-plus"></i></button>
            </td>
          </tr>
        </slot>
      </thead>
      <tbody v-if="rows" ref="tbody" @scroll="updateScroll">
        <template v-for="(x, key) in srows">
          <tr :key="key" :style="rowstyle(x)" :class="rowclass(x)">
            <template v-if="complete || move">
              <td :style="stylebtn()">
                <button class="btn btn-secondary fill" @click="moveup(key)">⇧</button>
              </td>
              <td :style="stylebtn()">
                <button class="btn btn-secondary fill" @click="movedown(key)">⇩</button>
              </td>
            </template>
            <template v-if="complete">
              <td :style="stylebtn()">
                <button class="btn btn-secondary small fill" @click="removeelement(key, x)">✘</button>
              </td>
              <td :style="stylebtn()">
                <button class="btn btn-primary small fill " @click="addelement(key)">✚</button>
              </td>
            </template>
            <td v-for="(col, k) in cols" :key="k" :class="tdcolclass(col, key, x)" @click="activaterow(key, x)">
              <slot v-bind="getdatabind(x, key)" :name="col.id">
                <template v-if="editable && !col.readonly">
                  <template v-if="col.type == 'coddes'">
                    <template v-if="col.id && col.id != '*'">
                      <d-coddes :value="x[col.id]" :table="col.table" small noborder @input="inputcodes(x[col.id], $event)" />
                    </template>
                    <template v-else>
                      <d-coddes :value="x" :table="col.table" small noborder @input="inputcodes(x, $event)" />
                    </template>
                  </template>
                  <template v-else-if="col.type == 'cod'">
                    <d-cod v-model="x[col.id]" :table="col.table" small noborder />
                  </template>
                  <template v-else-if="col.type == 'auth'">
                    <d-auth
                      v-model="x[col.id]"
                      small
                      noborder
                      :users="col.users"
                      :modules="col.modules"
                      :admins="col.admins"
                      :groups="col.groups"
                      :shops="col.shops"
                      :brands="col.brands"
                      :countries="col.countries"
                    />
                  </template>
                  <template v-else-if="col.type == 'number'">
                    <d-number v-model="x[col.id]" :conv="col.conv" small noborder />
                  </template>
                  <template v-else-if="col.type == 'date'">
                    <d-date v-model="x[col.id]" small noborder />
                  </template>
                  <template v-else-if="col.type == 'check'">
                    <d-input v-model="x[col.id]" type="check" small noborder />
                  </template>
                  <template v-else>
                    <input v-model="x[col.id]" :type="gettype(x[col.id])" class="form-control noborder px-2" />
                  <!-- <input :type="gettype(x[col.id])" class="small noborder px-2" v-model="x[col.id]" />	 -->
                  </template>
                </template>
                <template v-else>
                  <span class="px-2">{{ x[col.id] }}</span>
                </template>
              </slot>
            </td>
            <td v-if="details" :style="stylebtn(2)">
              <button class="btn btn-secondary fill" @click="dodetails(key)">{{ arrowkey(key) }}</button>
            </td>
            <td v-if="fadd" :style="stylebtn()" :disabled="disablebtnremove(key)">
              <button v-if="add || key == rows.length - 1" class="btn btn-primary small" @click="removeelement(key, x)"><i class="di di-close"></i></button>
            </td>
          </tr>
          <transition :key="key" name="detail">
            <tr v-if="detailrow == key && details">
              <td colspan="100" class="tddetail">
                <slot v-bind="getdatabind(x, key)" name="_detail">
                  <d-json :value="x" />
                </slot>
              </td>
            </tr>
          </transition>
        </template>
      </tbody>
      <tfoot v-if="rowtotal" ref="tfoot">
        <tr>
          <th v-for="(col, key) in cols" :key="key" :style="stylecol(col)">
            <slot v-bind="rowtotal" :name="col.id"> {{ x[col.id] }}</slot>
          </th>
          <th v-if="details" :style="stylebtn(2)"></th>
          <th v-if="fadd" :style="stylebtn()" />
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
    const BTNSIZE = 30;
    export default {
        name: "Vtable",
        props: {
            editable: Boolean,
            details: Boolean,
            add: Boolean,
            addend: Boolean,
            move: Boolean,
            rowtotal: Array,
            width: String,
            sortable: Boolean,
            columns: Array,
            rows: Array,
            height: String,
            bottom: String,
            selected: String,
            searchtext: String,
            cansort: Boolean,
            complete: Boolean,
            extra: Object
        },
        data() {
            return {
                cwidth: 0,
                cheight: 0,
                detailrow: -1,
                activerow: -1,
                sel: {},
                sortasc: true,
                sortcol: null,
                myinterval: undefined
            };
        },
        computed: {
            autoscroll() {
                return this.height || this.bottom;
            },
            fadd() {
                return this.add || this.addend;
            },
            srows() {
                if ((!this.sortcol && !this.searchtext) || this.editable || !this.rows || this.complete || this.move) {
                    return this.rows;
                } else {
                    var sc = this;
                    var data = sc.rows.slice();
                    for (var i = 0; i < data.length; i++) data[i]._id = i;
                    if (this.searchtext) {
                        var ss = this.searchtext.toLowerCase();
                        data = data.filter(function (row) {
                            return Object.keys(row).some(function (key) {
                                return (
                                    String(row[key])
                                        .toLowerCase()
                                        .indexOf(ss) > -1
                                );
                            });
                        });
                    }
                    if (this.sortcol && this.cansort) {
                        data.sort((a, b) => {
                            a = a[sc.sortcol];
                            b = b[sc.sortcol];
                            if (sc.sortasc) return a === b ? 0 : a > b ? 1 : -1;
                            return a === b ? 0 : a > b ? -1 : 1;
                        });
                    }
                    return data;
                }
            },
            cols() {
                var ret = this.columns;
                if (!this.columns && this.rows && this.rows[0]) {
                    ret = [];
                    var v = Object.keys(this.rows[0]);
                    for (var i = 0; i < v.length; i++) {
                        ret.push({id: v[i], title: v[i]});
                    }
                }
                var t = 0;
                var s = this.cwidth - 15;
                if (ret) {
                    for (var i = 0; i < ret.length; i++) {
                        if (!ret[i].w) ret[i].w = 1;
                        if (ret[i].w > 0) {
                            t += ret[i].w;
                        } else {
                            s += ret[i].w * (BTNSIZE + 3);
                        }
                    }
                }
                if (t) {
                    if (this.fadd) s -= BTNSIZE + 3;
                    if (this.details) s -= BTNSIZE + 3;
                    if (this.complete) s -= (BTNSIZE + 3) * 4;
                    if (this.move) s -= (BTNSIZE + 3) * 2;
                    s /= t;
                    for (var i = 0; i < ret.length; i++) {
                        if (ret[i].w < 0) {
                            ret[i].wc = -ret[i].w * BTNSIZE;
                        } else {
                            ret[i].wc = Math.floor(ret[i].w * s);
                        }
                    }
                }
                return ret;
            },
            tbodyClass() {
                return this.width ? "" : "noscrollx";
            },
            boxStyle() {
                if (this.autoscroll) {
                    var q = this.height;
                    if (q) {
                        return {
                            maxHeight: q,
                            overflowY: "auto"
                        };
                    } else if (this.cheight > 0) {
                        q = this.cheight + "px";
                        return {
                            overflowY: "auto",
                            height: q
                        };
                    }
                }
                return {};
            }
        },
        mounted() {
            //window.addEventListener('resize', this.resize);
            //		this.myinterval=setInterval(this.resize,300);
            this.$nextTick(() => {
                this.resize();
                this.updateScroll();
            });
        },
        beforeDestroy() {
            clearInterval(this.myinterval);
            //window.removeEventListener('resize', this.resize);
        },
        methods: {
            moveup(key) {
                if (key > 0) this.rows[key] = this.rows.splice(key - 1, 1, this.rows[key])[0];
            },
            movedown(key) {
                if (key + 1 < this.rows.length) {
                    this.rows[key] = this.rows.splice(key + 1, 1, this.rows[key])[0];
                }
            },
            arrowkey(key) {
                return this.detailrow == key && this.details ? String.fromCharCode(9650) : String.fromCharCode(9660);
            },
            keypress(e) {
            },
            getdatabind(x, key) {
                return {data: x, key: key};
            },
            gettype(id) {
                if (typeof id == "boolean") return "checkbox";
                else if (typeof id == "number") return "number";
                else return "text";
            },
            removeelement(key, row) {
                if (this.addend && key != this.rows.length - 1) return;
                this.rows.splice(key, 1);
                this.$forceUpdate();
            },
            addelement(key) {
                var x1 = {};
                // risolve automaticamente i coddes
                if (this.columns) {
                    this.columns.forEach(e => {
                        if (e.type == "coddes") {
                            if ((e.id = "*" || e.id == "")) {
                                x1.cod = "";
                                x1.des = "";
                            } else {
                                x1[e.id].cod = "";
                                x1[e.id].des = "";
                            }
                        }
                    });
                }
                this.$emit("addelement", x1);
                if (this.complete) {
                    if (key) {
                        this.rows.splice(key, 0, x1);
                    } else {
                        this.rows.push(x1);
                    }
                } else if (this.add) {
                    this.rows.unshift(x1);
                    this.$refs.tbody.scrollTop = 0;
                } else {
                    this.rows.push(x1);
                }
                this.$forceUpdate();
            },
            rowstyle(x) {
                if (this.extra && this.extra.rowstyle && typeof this.extra.rowstyle == "function") {
                    return this.extra.rowstyle(x);
                }
                return {};
            },
            rowclass(x) {
                if (this.extra && this.extra.rowclass && typeof this.extra.rowclass == "function") {
                    return this.extra.rowclass(x);
                }
                return "";
            },
            updateScroll() {
                const b = this.$refs.tbody;
                if (!b) return;
                const l = b.scrollLeft;
                const h = this.$refs.thead;
                const f = this.$refs.tfoot;
                if (h && h.scrollLeft !== l) h.scrollLeft = l;
                if (f && f.scrollLeft !== l) f.scrollLeft = l;

                var x = b.getBoundingClientRect().height;
                if (x > 0) {
                    if (b.scrollTop + x >= b.scrollHeight - 5) {
                        this.$emit("scrolltoend");
                    }
                    this.$emit("scroll", b.scrollTop, l, b.scrollHeight, b.scrollWidth);
                }
            },
            stylebtn(n) {
                /*var x = n ? n * BTNSIZE : BTNSIZE;
                return {
                    width: x + "px",
                    minWidth: x + "px",
                    maxWidth: x + "px"
                };*/
            },
            disablebtnremove(row) {
                if (this.add || row == this.rows.length - 1) return false;
                return true;
            },
            stylecol(col) {
                /*if (col.wc > 0) {
                    return {
                        width: col.wc + "px",
                        minWidth: col.wc + "px",
                        maxWidth: col.wc + "px"
                    };
                } else {
                    return {display: "hidden"};
                }*/
            },
            tdcolstyle(col, key, x) {
                /*var r = this.stylecol(col);
                if (!this.editable) r.cursor = "pointer";
                switch (col.style) {
                    case "R":
                        r.textAlign = "right";
                        break;
                    case "C":
                        r.textAlign = "center";
                        break;
                    default:
                        break;
                }
                if (this.extra && this.extra.colstyle) this.extra.colstyle(r, x, col);*/
                // return r;
            },
            tdcolclass(col, k, r) {
                let aa = col.class || "";
                if (r.cod && this.selected && r.cod.toLowerCase() === this.selected.toLowerCase()) {
                    aa += " selected";
                }
                if (this.activerow === k && !this.editable) {
                    aa += " tdactive";
                }
                if (this.extra && this.extra.colclass) {
                    aa += this.extra.colclass(r, col);
                }
                // return aa;
            },
            changesort(k) {
                if (!this.fadd && !this.editable) {
                    if (this.sortcol === k) {
                        if (this.sortasc) this.sortasc = false;
                        else this.sortcol = null;
                    } else {
                        this.sortcol = k;
                        this.sortasc = true;
                    }
                    this.$emit("sorttable", {col: this.sortcol, asc: this.sortasc});
                }
            },
            dodetails(k) {
                if (k === this.detailrow) this.detailrow = -1;
                else {
                    this.$emit("detailrow", k);
                    this.detailrow = k;
                }
            },
            getsorted() {
                return this.sortasc ? "asc" : "des";
            },
            activaterow(r, x) {
                if (x && x._id) {
                    this.$emit("select", x._id);
                } else {
                    this.$emit("select", r);
                }
                this.activerow = r;
            },
            resize() {
                this.cheight = 0;
                var rx = this.$refs.table;
                if (!rx) return;
                var rr = rx.getBoundingClientRect();
                if (this.autoscroll) {
                    if (this.bottom) {
                        var el2 = document.getElementById("mainfooter");
                        if (el2 == null) {
                            this.cheight = window.innerHeight - rr.top - parseInt(this.bottom);
                        } else {
                            var x2 = el2.getBoundingClientRect();
                            this.cheight = x2.top - rr.top - parseInt(this.bottom);
                        }
                    }
                }
                var q = parseInt(this.width);
                this.cwidth = q > 0 ? q : rr.width;
            },
            inputcodes(x, e) {
                x.cod = e.cod;
                x.des = e.des;
            }
        }
        /*beforeUpdated() {
                this.resize();
                this.updateScroll();

        },
        */
    };
</script>
<style scoped lang="scss">
  @keyframes detail {
    from {
      transform: rotateX(90deg);
      opacity: 0;
    }
    to {
      transform: rotateX(0);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/_eng/globals/dtable.vue